import EzUtils from "../../utils/EzUtils";
import StorageUtil from "../../utils/StorageUtil";

const ASSOCIATED_ENTITY_DATA = "associatedEntityData";


export default {

  clearAssociatedEntityData() {
    StorageUtil.removeItem(ASSOCIATED_ENTITY_DATA);
  },

  setAssociatedEntityData(associatedEntityData) {
    StorageUtil.setItem(ASSOCIATED_ENTITY_DATA,
        JSON.stringify(associatedEntityData)
    );
  },

  getAssociatedEntityData() {
    const associatedEntityData = EzUtils.convertToJSONObjectIfString(
        StorageUtil.getItem(ASSOCIATED_ENTITY_DATA)
    );
    return associatedEntityData ? associatedEntityData : {};
  },

  setAssociatedEntityDetails(
      parentLoanId, parentLoanPrice, parentApplicantType,
      allowAssociatedLoanCreation, associatedEntityTypes,
      associatedEntityConfig, heading, toolbarTitle
  ) {
    const associatedEntityData = this.getAssociatedEntityData();

    associatedEntityData.parentLoanId = parentLoanId;
    associatedEntityData.parentLoanPrice = parentLoanPrice;
    associatedEntityData.parentApplicantType = parentApplicantType;
    associatedEntityData.allowAssociatedLoanCreation = allowAssociatedLoanCreation;
    associatedEntityData.associatedEntityTypes = associatedEntityTypes;
    associatedEntityData.associatedEntityConfig = associatedEntityConfig;
    associatedEntityData.heading = heading;
    associatedEntityData.toolbarTitle = toolbarTitle;

    this.setAssociatedEntityData(associatedEntityData);
  },

  getParentLoanId() {
    const associatedEntityData = this.getAssociatedEntityData();
    return associatedEntityData.parentLoanId;
  },

  getParentLoanPrice() {
    const associatedEntityData = this.getAssociatedEntityData();
    return associatedEntityData.parentLoanPrice;
  },

  getParentApplicantType() {
    const associatedEntityData = this.getAssociatedEntityData();
    return associatedEntityData.parentApplicantType;
  },

  isAllowAssociatedLoanCreation() {
    const associatedEntityData = this.getAssociatedEntityData();
    return associatedEntityData.allowAssociatedLoanCreation;
  },

  getAssociatedEntityTypes() {
    const associatedEntityData = this.getAssociatedEntityData();
    return associatedEntityData.associatedEntityTypes;
  },

  getAssociatedEntityConfig() {
    const associatedEntityData = this.getAssociatedEntityData();
    return associatedEntityData.associatedEntityConfig;
  },

  getHeading() {
    const associatedEntityData = this.getAssociatedEntityData();
    return associatedEntityData.heading;
  },

  getToolbarTitle() {
    const associatedEntityData = this.getAssociatedEntityData();
    return associatedEntityData.toolbarTitle
        ? associatedEntityData.toolbarTitle
        : "";
  }
};

